<fieldset>
    <div class="group-div">
        <div class="header">
            <!--<img src="../../../../assets/add-button.png" class="add-image" alt="+">-->
            <button mat-raised-button color="primary" (click)="onButtonClick.emit('add'); addGroup();"> 
            <mat-icon>add</mat-icon>
            </button>
        </div>
        <div  *ngFor="let group of groups;  let i = index;" (mouseover)="mouseIndex = i;" (mouseleave)="mouseIndex = -1;">
        <!--Big grey boxes for each group-->
            <!--Big grey boxes for each group-->
            <div class="group" (click)="onButtonClick.emit('open'); toggleOpen(i);">
                
                <ng-container *ngIf="editIndex != i;">
                    <div class='label'>{{group.groupName}}</div>
                </ng-container>
                <ng-container *ngIf="editIndex == i;">
                    <input name="group" class="d-form" type="text" placeholder="Group Name" [(ngModel)]="group.groupName">
                </ng-container>
            
                <div [ngClass]="((mouseIndex == i || editIndex == i) && editSubIndex==-1)? ' show': ' hide'">
                    <ng-container *ngIf="editIndex != i && editIndex == -1">
                        <button mat-icon-button enabled="mouseIndex == i" (click)="onButtonClick.emit('edit'); editGroup($event, i);"><mat-icon>create</mat-icon></button>
                        <button mat-icon-button enabled="mouseIndex == i" (click)="onButtonClick.emit('add'); addQueue(group,group.queues.length,i);"><mat-icon>add</mat-icon></button>
                        <ng-container *ngIf="group.queues.length == 0">
                            <button mat-icon-button color="accent" enabled="mouseIndex == i" (click)="onButtonClick.emit('delete'); deleteGroup(i);"><mat-icon>delete</mat-icon></button>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="editIndex == i">
                        <button mat-icon-button enabled="mouseIndex == i" (click)="onButtonClick.emit('save'); saveChanges(group);" [disabled]="isValid"><mat-icon>done</mat-icon></button>
                        <button mat-icon-button color="accent" enabled="mouseIndex == i" (click)="onButtonClick.emit('cancel'); cancel();"><mat-icon>close</mat-icon></button>
                    </ng-container>
                    
                </div>
            </div>

            <!--Little white boxes for each queue-->
            <ng-container *ngIf="openIndex == i">
                <div class="queue" *ngFor="let queue of group.queues; let j = index;" (mouseover)="mouseSubIndex = j;" (mouseleave)="mouseSubIndex = -1;">
                    
                    <ng-container *ngIf="editIndex == i || editSubIndex != j">
                        <span class="queueText">{{queue}}</span>
                    </ng-container>
                    <ng-container *ngIf="editSubIndex == j">
                        <span class="queueText">
                            <select [(ngModel)]="group.queues[j]">
                                <option *ngFor = "let queueName of grouplessQueues" [ngValue]="queueName">{{queueName}}</option>
                            </select>
                        </span>
                    </ng-container>

                    <div [ngClass]="((mouseIndex == i && mouseSubIndex == j) || (editSubIndex == j))? ' show': ' hide'">
                        <ng-container *ngIf="editSubIndex != j && editSubIndex == -1">
                            <button enabled="mouseIndex == i" ><div uk-icon="trash"(click)="onButtonClick.emit('delete'); deleteQueue(queue);"></div></button>
                        </ng-container>
                        <ng-container *ngIf="editSubIndex == j">
                            <button enabled="mouseIndex == i" (click)="onButtonClick.emit('save'); saveQueueChanges(queue, group);" [disabled]="isValid"><div uk-icon="check"></div></button>
                            <button enabled="mouseIndex == i" (click)="onButtonClick.emit('cancel'); cancel();"><div uk-icon="close"></div></button>
                        </ng-container>
                        
                    </div>
                </div>
                <ng-container *ngIf="group.queues.length == 0">
                    <span class="queueText">
                        No queues in this group.
                    </span>
                </ng-container>
            </ng-container>
            
        </div>
    </div>
<!-- {{_queueData| json}}<br><br>{{_groupData| json}}<br><br>{{grouplessQueues| json}}<br><br>{{groups | json}} -->
</fieldset>